import { render, staticRenderFns } from "./dateDiff.vue?vue&type=template&id=22f7b0de&"
import script from "./dateDiff.vue?vue&type=script&lang=js&"
export * from "./dateDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-co_kc4kqcj5wnuaaoi4dyztoye7yy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports